import { create } from "zustand";

interface AppState {
  selectedOrgId: string | null;
  selectedSiteId: string | null;
  sidebarCollapsed: boolean;
  commandPaletteOpen: boolean;

  setSelectedOrg: (orgId: string | null) => void;
  setSelectedSite: (siteId: string | null) => void;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setCommandPaletteOpen: (open: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  selectedOrgId: localStorage.getItem("selectedOrgId"),
  selectedSiteId: localStorage.getItem("selectedSiteId"),
  sidebarCollapsed: localStorage.getItem("sidebarCollapsed") === "true",
  commandPaletteOpen: false,

  setSelectedOrg: (orgId: string | null) => {
    if (orgId) {
      localStorage.setItem("selectedOrgId", orgId);
    } else {
      localStorage.removeItem("selectedOrgId");
    }
    localStorage.removeItem("selectedSiteId");
    set({ selectedOrgId: orgId, selectedSiteId: null });
  },

  setSelectedSite: (siteId: string | null) => {
    if (siteId) {
      localStorage.setItem("selectedSiteId", siteId);
    } else {
      localStorage.removeItem("selectedSiteId");
    }
    set({ selectedSiteId: siteId });
  },

  toggleSidebar: () =>
    set((state) => {
      const newVal = !state.sidebarCollapsed;
      localStorage.setItem("sidebarCollapsed", String(newVal));
      return { sidebarCollapsed: newVal };
    }),

  setSidebarCollapsed: (collapsed: boolean) => {
    localStorage.setItem("sidebarCollapsed", String(collapsed));
    set({ sidebarCollapsed: collapsed });
  },

  setCommandPaletteOpen: (open: boolean) => set({ commandPaletteOpen: open }),
}));
